import React from 'react';
import { getTrackName } from '@jbrowse/core/util/tracks';
import { getSession } from '@jbrowse/core/util';
import SVGRegionSeparators from './SVGRegionSeparators';
import SVGTrackLabel from './SVGTrackLabel';
// SVG component, tracks
export default function SVGTracks(_ref) {
  var displayResults = _ref.displayResults,
    model = _ref.model,
    offset = _ref.offset,
    textHeight = _ref.textHeight,
    fontSize = _ref.fontSize,
    _ref$trackLabels = _ref.trackLabels,
    trackLabels = _ref$trackLabels === void 0 ? 'offset' : _ref$trackLabels,
    _ref$trackLabelOffset = _ref.trackLabelOffset,
    trackLabelOffset = _ref$trackLabelOffset === void 0 ? 0 : _ref$trackLabelOffset;
  var session = getSession(model);
  var textOffset = trackLabels === 'offset' ? textHeight : 0;
  return React.createElement(React.Fragment, null, displayResults.map(function (_ref2) {
    var track = _ref2.track,
      result = _ref2.result;
    var current = offset;
    var conf = track.configuration;
    var trackName = getTrackName(conf, session);
    var display = track.displays[0];
    var x = Math.max(-model.offsetPx, 0);
    offset += display.height + textOffset;
    return React.createElement("g", {
      key: conf.trackId,
      transform: "translate(0 ".concat(current, ")")
    }, React.createElement("g", {
      transform: "translate(".concat(trackLabelOffset, " ").concat(textOffset, ")")
    }, React.createElement(SVGRegionSeparators, {
      model: model,
      height: display.height
    }), result), React.createElement(SVGTrackLabel, {
      trackName: trackName,
      fontSize: fontSize,
      trackLabels: trackLabels,
      trackLabelOffset: trackLabelOffset,
      x: x
    }));
  }));
}